import BorderColorIcon from '@mui/icons-material/BorderColor';
import CalculateIcon from '@mui/icons-material/Calculate';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Slider,
  SwipeableDrawer,
  Switch,
  Tab,
  TablePagination,
  Tabs,
  TextField,
  Typography
} from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Chip from '@mui/material/Chip';
import InputBase from '@mui/material/InputBase';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { decode } from 'base-64';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import * as Yup from 'yup';
import { api } from '../api';
import AuthContext from "../auth/AuthProvider";
import { fetchName, fetchToken } from '../auth/Token';
import Header from "../components/Header";
import LoanAdviseCommodity from '../components/LoanAdviseCommodity';
import PriceChart from '../components/PriceChart';
import { useMode } from "../theme";


const FormatedDate = ({ value }) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };

  const formattedDate = date.toLocaleString('en-US', options);
  return <span>{formattedDate}</span>;
};

const FormatedDateRepayments = ({ value }) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  const formattedDate = date.toLocaleString('en-US', options);
  return <span>{formattedDate}</span>;
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(26, 32, 39, 0.5)' : 'rgba(255, 255, 255, 0.2)',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: '8px',
}));

const Item_order_buy = styled(Paper)(({ theme }) => ({
  backgroundColor: '#3a0ca3',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: '4px',
  display: 'flex',
  borderRadius: '18px',
}));

const Item_order_sell = styled(Paper)(({ theme }) => ({
  backgroundColor: '#d90429',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: '4px',
  display: 'flex',
  borderRadius: '18px',
}));

const Itemc = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(26, 32, 39, 0.5)' : 'rgba(255, 255, 255, 0.2)',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: '8px',
  marginTop: '5px',
}));

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    width: '918vh',
    maxHeight: '180vh',
    // overflow: 'auto'
  },
}));


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function DemChips(props){
  return (
  <Chip label={
    <div style={{ display: 'block' }}>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Id: <b>{props.id}</b></Typography>
      {/* <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Date: <b><FormatedDate value={props.date} /></b></Typography> */}
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Bags: <b>{props.bags}</b></Typography>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'><b>{props.grade}</b></Typography>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'><b>{props.unit}units</b></Typography>
      <Typography fontStyle='Italic' variant='subtitle'><b>{props.cash}</b></Typography>
    </div>
  } 
  key={props.id}
  />
  )
}

const PrettoSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

const MessageBox_com = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  margin: '4px',
  maxWidth:'310px',
  display: 'flex',
  borderRadius: '20px',
  marginLeft: 'auto',
  display: 'flex', 
  flexDirection: 'column',
}));

const MessageBox_goi = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  margin: '4px',
  maxWidth:'310px',
  display: 'flex',
  borderRadius: '20px',
  display: 'flex', 
  flexDirection: 'column',
}));

const ChatUI = ({order_id, setUi}) => {
  const [open, setOpen] = React.useState(true);
  const [chats, setChats] = useState([]);
  const [details, setDetails] = useState();
  const [header_details, setHeader_Details] = useState();
  const [uimage, setUimage] = useState();
  const [message, setMessage] = useState('')
  const [final_price, setFinal_price] = useState(details?.aggreed_price?details?.aggreed_price:null);
  const [agree, setAgree] = useState(details?.agree);
  const [personaInfo, setPersonaInfo] = useState([]);


  useEffect(()=>{
    const data = new FormData()
    data.append('nego_id', details?.nego_id)
    data.append('agree_price', final_price)
    api.post('/account/set/agree/on/price', data, {
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      negotiate()
    }).catch(function (error){
      console.log(error)
    })
  },[final_price])

  const make_agree =  () => {
    setAgree(prevState => !prevState)
    const data = new FormData()
    data.append('nego_id', details?.nego_id)
    data.append('agree', agree)
    api.post('/account/agree/on/price', data, {
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      negotiate()
    }).catch(function (error){
      console.log(error)
    })
  }


  const handleClose = () => {
    setOpen(false);
  };

  const negotiate = () => {
    const data = new FormData()
    data.append('order_id', order_id)
    api.post('/account/open/negotiation', data, {
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setChats(response.data?.Chats);
      setDetails(response.data?.details);
      setHeader_Details(response.data?.header_details);
      setUimage(response.data?.user_image);
    }).catch(function (error){
      console.log(error)
    })
  }

  const fetchImage = () => {
    api.get('/users/su',{
      headers: {
          Authorization: 'Bearer '+ fetchToken()
      }
    }).then(function (response){
      setPersonaInfo(response.data)
    }).catch(function (error){
      console.log(error)
    }) 
  }
  const negotiate_chats = () => {
    const data = new FormData()
    data.append('order_id', order_id)
    api.post('/account/open/negotiation', data, {
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setChats(response.data?.Chats);
    }).catch(function (error){
      console.log(error)
    })
  }

  useEffect(()=>{
    negotiate_chats()
    const intervalId = setInterval(negotiate_chats, 2000);
    return () => clearInterval(intervalId);
  },[])

  useEffect(()=>{
    negotiate();
    fetchImage();
  },[order_id])

  const sendMessage = (event) => {
    event.preventDefault()
    const data = new FormData()
    data.append('nego_id', details.nego_id);
    data.append('message', message);

    api.post('/account/send/message', data, {
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      negotiate_chats();
      setMessage('');
    }).catch(function (error){
      console.log(error)
    })
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '480px',
    maxHeight: '550vh', 
    overflowY: 'auto', 
    bgcolor: '#edede9',
    borderRadius: '7px',
    boxShadow: 24,
    p: 2,
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });
  
  return(
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box sx={style}>
      {
        details && details?
        <>
          <Box sx={{marginRight:'auto'}}><IconButton onClick={() => setUi()} color='error'><CancelIcon /></IconButton></Box>
          <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#f1faee', borderTopLeftRadius: '7px', borderTopRightRadius: '7px', paddingTop: 2, paddingBottom:2 }}>
            <Avatar alt={header_details?.username} src={pic(uimage)} sx={{ width: 65, height: 65 }}/>
            <Typography variant='body2'><b>{header_details?.username}</b></Typography>
            <Typography variant='body2'><b>{header_details?.warehouse}</b></Typography>
          </Box>
          <Box sx={{mt:1, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Aggreed Price:  </b> 
                <TextField
                  value={final_price}
                  onChange={e=>setFinal_price(e.target.value)}
                  label="Final Price"
                  type="number"
                  size='small'
                  sx={{ ml:1, borderRadius:7 }}
                /> 
                <IconButton color={agree === true?'primary':'success'} onClick={make_agree}><CheckCircleIcon /></IconButton>
            </Typography>
          </Box>
          <Box sx={{ mt:2,mb:1, maxHeight: "40vh", overflow:'auto', '&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
            {
            chats && chats.slice().reverse().map((item) => (
              item.username === fetchName() ?
              <MessageBox_com>
              <div style={{ marginBottom:'3px' }}><Typography variant='subtitle'><b style={{marginRight:'5px'}}>You</b><FormatedDate value={item.datetime} /></Typography></div>
                  <div>
                    <Typography>
                      <span>{item.message}</span>
                    </Typography>
                  </div>
              </MessageBox_com>
              :
                <MessageBox_goi>
                <div style={{ marginBottom:'3px' }}><Typography variant='subtitle'><b style={{marginRight:'5px'}}>{item.username}</b><FormatedDate value={item.datetime} /></Typography></div>
                  <div>
                    <Typography>
                      <span>{item.message}</span>
                    </Typography>
                  </div>
                </MessageBox_goi>
              ))
          }
          </Box>
          <Box sx={{ display:'flex', flexDirection:'row' }}>
            <form onSubmit={sendMessage}>
              <TextField
                required
                size='small'
                sx={{ borderRadius:20,mt:2,width:'360px' }}
                placeholder='Type a message'
                value={message}
                onChange={(e)=>setMessage(e.target.value)}
              />
              <IconButton sx={{mt:2,ml:'3px'}} size='small' onClick={sendMessage} color='secondary'><SendIcon /></IconButton>
            </form>
          </Box>
            
        </>
        : <CircularProgress />
      }
      
      </Box>
    </Modal>
  )
}

const DetailsModal = ({item}) => {
  const [open_mod, setOpen_mod] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [ui, setUi] = useState()
  // const [open, setOpen] = useState(false)

  const negotiate = () => {
    setUi(
        <ChatUI 
          order_id={item.order_id}
          setUi={setUi}
        />
      )
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '580px',
    maxHeight: '150vh', 
    overflowY: 'auto', 
    bgcolor: 'background.paper',
    border: '1px solid #e7ecef',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  return(
      <>
        <Chip size='small' onClick={() => setOpen_mod(true)} sx={{ margin: '4px',mt:1, backgroundColor: item.order_type === "Sell"?'#d90429':'#3a0ca3' }} label={<b style={{ color:'#fff' }}>View details</b>} />
        <Modal
          open={open_mod}
          onClose={() => setOpen_mod(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
          {ui}
              <Grid container>
                <Grid item xs={12} md={12}>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle' sx={{textAlign:'center'}}><b>Order Details</b></Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle' sx={{textAlign:'center'}}><b>{item.order_type === "Buy"? "(Buying)": "(Selling)"}</b></Typography>
                <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Commodity: <b>{item.commodity}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Order date: <b><FormatedDate value={item.date} /></b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Order type: <b>{item.order_type}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Bags: <b>{item.bags}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Grade: <b>{item.grade}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Unit: <b>{item.unit}</b>
                    </Typography>
                  </div>
                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Note: 
                        <div>
                          <b>{item.message}</b>
                        </div>
                    </Typography>
                  </div>

                  {
                    item.order_type === "Sell"?
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Selling Price: <b>{currencyFormat.format(item.open_price)}</b>
                      </Typography>
                    </div>:
                    null
                  }

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      {item.commodity} price on order date: 
                      <div>Grade A: <b>{currencyFormat.format(item.grade_a)}</b></div>
                      <div>Grade B: <b>{currencyFormat.format(item.grade_b)}</b></div>
                      <div>Grade C: <b>{currencyFormat.format(item.grade_c)}</b></div>
                    </Typography>
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Avatar
                      sx={{ width: 65, height: 65 }}
                      alt={item.member_name}
                      src={pic(item.member_image)}
                    />  
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Member name: <b>{item.member_name}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Member phone: <b>{item.member_phone}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Community: <b>{item.community.community_name}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Savings Group: <b>{item.association.association_name}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Kind: <b>{item.kind.association_type}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Cluster: <b>{item.cluster.cluster_name}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Society: <b>{item.society.society}</b>
                    </Typography>
                  </div>

                  <div style={{display:'flex', marginTop:'5px'}}>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                    >
                      Warehouse: <b>{item.warehouse_details.warehouse}</b>
                    </Typography>
                  </div>

                </Grid>
                <Grid item xs={12} md={12}>
                  <Button
                    size='small'
                    variant='contained'
                    color='success'
                    sx={{ mr:'4px' }}
                    onClick={negotiate}
                  >
                  {
                    loading === true?
                    <CircularProgress size={15} />
                    :"Negotiate"
                  }
                  </Button>

                  <Button
                    size='small'
                    variant='contained'
                    color='error'
                    onClick={()=>setOpen_mod(false)}
                  >
                    Close
                  </Button>
                </Grid>
              </Grid>
          </Box>
        </Modal>
      </>
  )
}



const Trade = ({ 
  warehouse, 
  commodity, 
  commodity_id, 
  member_acc_id, 
  society_id, 
  warehouse_id, 
  society_name,
  fetch_all_orders 
}) => {
  const [general_prices, setGeneral_prices] = useState([]);
  const [general_units, setGeneral_units] = useState([]);
  const [my_info, setMy_info] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [grade_edit, setGrade_edit] = useState(null);
  const [unit_edit, setUnit_edit] = useState(null);
  const [number_of_bags_edit, setNumber_of_bags_edit] = useState(null);
  const [specs_edit, setSpecs_edit] = useState('');
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked10, setChecked10] = useState(true);
  const [est_from, setEst_from] = useState(null);
  const [est_to, setEst_to] = useState(null);
  const [openn, setOpenn] = useState(false);
  const [orders_open, setOrders_open] = useState([]);
  const [orders_closed, setOrders_closed] = useState([]);
  const [orders_pending, setOrders_pending] = useState([]);
  const [available_sells, setAvailable_sells] = useState()
  const [num_komot, setNum_komot] = useState()
  const [selling_price, setSelling_price] = useState(null)
  const [selling_price1, setSelling_price1] = useState(null)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [edit_details, setEdit_details] = useState([]);
  const [modal_Open, setModal_open] = useState(false);
  const [modal_Open1, setModal_open1] = useState(false);
  const [error1, setError1] = useState('');
  const [chartData_a, setChartData_a] = useState([]);
  const [chartData_b, setChartData_b] = useState([]);
  const [chartData_c, setChartData_c] = useState([]);
  const [slider_value, setSlider_value] = useState(40);
  const [slider_final, setSlider_final] = useState();
  const [requested_amount, setRequested_amount] = useState(null);
  const [requested, setRequested] = useState(false);
  const [deka_amount, setDeka_amount] = useState(false);
  const [loans_orders, setLoans_orders] = useState([]);
  const [repayment_starts, setRepayment_starts] = useState();
  const [repayment_ends, setRepayment_ends] = useState();
  const [repayment_amount, setRepayment_amount] = useState(null);
  const [percent, setPercent] = useState(null);
  const {  permissions } = useContext(AuthContext);
  const [opennn, setOpennn] = useState();


  const changeSliderValue = (e) => {
    setSlider_value(e.target.value);
    setSlider_final((e.target.value / 100) * my_info.cash_val)
  }

  const [priceData, setPriceData] = useState({
    commodity_name: commodity,
    grade: "Grade A"
  });

  const requestLoan = () => {
    const values = {
      transactiontype_id: 2,
      Amount: slider_final,
      narration: 'Commodity Loan',
      loans_acc_id: member_acc_id,
      type: "commodity",
      percent: slider_value
    }
    api.post('/transactions/transaction/loans', values , {
      headers: {
          Authorization:'Bearer ' + fetchToken(),
      },
    }).then(function (response) {
        if(response.data === "Warehouse loan account not available"){
          toast.warning(response.data);
        }else{
          toast.success(response.data);
          setRequested_amount(values.Amount);
          get_orders();
          fetch_all_orders()
        }
    }).catch(function (error){
        console.log(error)
    })
  }

  const cancelrequestLoan = () => {
    const data = new FormData()
    data.append('member_acc_id', member_acc_id)
    data.append('req_amount', requested_amount)

    api.post('/account/cancel/commodity/loan/request', data , {
      headers: {
          Authorization:'Bearer ' + fetchToken(),
      },
    }).then(function (response) {
        toast.success(response.data);
        setRequested_amount();
        get_orders();
        fetch_all_orders()
    }).catch(function (error){
        console.log(error)
    })
  }

  const changeChart = (grade) => {
    setPriceData({
      commodity_name: commodity,
      grade: grade
    })
  }

  const fetch_chart_data = () => {
    api.get(`/account/chart/price/${commodity_id}`,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setChartData_a(response.data?.Grade_A);
      setChartData_b(response.data?.Grade_B);
      setChartData_c(response.data?.Grade_C);
    }).catch(function (error){
      console.log(error)
    })
  }


  useEffect(()=>{
    fetch_chart_data();
    // const intervalId = setInterval(fetch_chart_data, 2000);
    // return () => clearInterval(intervalId);
  },[])

  // const data = {
  //   labels: Object.keys(data).chartData.map(item => item.date),
  //   datasets: Object.keys(data).chartData.map((item) => ({
  //       label: item.date,
  //       data: item.new_price_per_kg,
  //       borderColor: 'rgb(255, 99, 132)',
  //       backgroundColor: 'rgba(255, 99, 132, 0.5)',
  //   }))
  // }


  useEffect(()=>{
    fetch_chart_data();
  },[commodity_id])
  


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloses = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '580px',
    maxHeight: '150vh', 
    overflowY: 'auto', 
    bgcolor: 'background.paper',
    border: '1px solid #e7ecef',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handleFormChange = (event) =>  {
    setChecked(event.target.checked);
  }
  const handleFormChange1 = (event) =>  {
    setChecked1(event.target.checked);
  }
  const handleFormChange10 = (event) =>  {
    setChecked10(event.target.checked);
  }


const get_orders = () => {
  api.get(`/account/get/my/orders/${member_acc_id}`,{
    headers: {
      Authorization: 'Bearer ' + fetchToken()
    }
  }).then(function (response){ 
    setOrders_open(response.data.open);
    setOrders_pending(response.data.pending);
    setOrders_closed(response.data.closed);
    setLoans_orders(response.data?.loan);
    setDeka_amount(response.data?.deka_amount);
    setRepayment_starts(response.data?.repayment_starts);
    setRepayment_ends(response.data?.repayment_ends);
    setPercent(response.data?.percent);
    if(response.data?.request_pending === true){
      setRequested_amount(response.data?.request_pending_amount);
    }
    setRequested(response.data?.request_pending);
  }).catch(function (error){
    console.log(error)
  })
}

useEffect(()=>{
  get_orders();
},[member_acc_id])

  const get_available_bags = () => {
    const hh = new FormData()
      hh.append('member_acc_id', member_acc_id)
      hh.append('commodity_id', commodity_id)
      
      api.post('/account/get/specific/acts', hh,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setAvailable_sells(response.data?.transactions);
      }).finally(function (){
        handleCloses()
      })
  }

  useEffect(()=>{
    get_available_bags();
  },[])

  useEffect(()=>{
    const data = new FormData()
    data.append('member_acc_id', member_acc_id)
    data.append('commodity_id', commodity_id)

    api.post('/commodity/the/other/side',data,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setMy_info(response.data);
        setIsLoading(false);
      }).catch(function (error){
        console.log(error)
      })
  },[commodity_id, member_acc_id])

  const pic = (pic) => {
    if (isLoading) {
      return 'placeholder_image_url';
    }else{
      const de = decode(pic);
      return `data:image/jpeg;base64,${btoa(de)}`;
    }
  };

  const fetch_stuffs = (id) => {
    api.get(`/account/current/prices/${id}`,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setGeneral_prices(response.data?.price);
        setGeneral_units(response.data?.units);
      }).catch(function(error){
        console.log(error)
      })
  }

  const constant_fetch = () => {
    api.get(`/account/current/prices/${commodity_id}`,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setGeneral_prices(response.data?.price);
      setGeneral_units(response.data?.units);
    }).catch(function(error){
      console.log(error)
    })
  }

  const handle_modal_Closee = () => {
    constant_fetch()
    setModal_open(false)
  }

  useEffect(()=>{
    constant_fetch()
  },[commodity_id])


  const getInitials = (crop) => {
    const firstInitial = crop ? crop.charAt(0).toUpperCase() : '';
    const lastInitial = crop ? crop.charAt(1).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  };

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });


  const formik = useFormik({
    initialValues: {
      grade: 0,
      unitsKg: 0,
      quantity: 1,
      specs: ''
  },
  onSubmit: (values) => {
    if (values.quantity <= 0){
      toast.warning("Please  enter the nummber of bags you want to buy.")
    }else{
      handleOpen()
      const data = new FormData()
      data.append('commodity_id', commodity_id)
      data.append('grade_id', values.grade)
      data.append('unit_id', values.unitsKg)
      data.append('amount_storing', values.quantity)
      data.append('member_com_acc', member_acc_id)
      data.append('message', values.specs)
      api.post('/account/buy/order', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
         toast.success(response.data);
         formik.handleReset();
         get_orders();
         fetch_all_orders();
      }).catch(function (error){
        console.log(error)
      }).finally(function (){
        handleCloses()  
      })
    }
  }
})



const formik_sell = useFormik({
  initialValues: {
    transaction_id: null,
    quantity_sell: 1,
    specs_sell: '',
},
validationSchema: Yup.object({
  quantity_sell: Yup.number().max(num_komot, `You only have ${num_komot} bags`).min(0),
}),
onSubmit: (values) => {
  if (values.transaction_id <= 0){
    toast.warning("Please choose activity to sell from.")
  }else{
    handleOpen()
    const data = new FormData()
    data.append('commodity_id', commodity_id)
    data.append('transaction_id', values.transaction_id)
    data.append('quantity_sell', values.quantity_sell)
    data.append('specs_sell', values.specs_sell)
    data.append('member_acc_id', member_acc_id)
    data.append('selling_price', selling_price)
    api.post('/account/sell/order', data ,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
       toast.success(response.data);
       formik_sell.handleReset();
       setSelling_price(null)
       get_orders();
       setNum_komot();
       fetch_all_orders();
    }).catch(function (error){
      console.log(error)
    }).finally(function (){
      handleCloses()  
    })
  }
}
})




const est_price = () => {
    if (formik.values.quantity <= 0){
      toast.warning("Please  enter the nummber of bags you want to buy.")
    }else{
      setLoading(true)
      const data = new FormData()
      data.append('commodity_id', commodity_id)
      data.append('grade_id', formik.values.grade)
      data.append('unit_id', formik.values.unitsKg)
      data.append('amount_storing', formik.values.quantity)
      data.append('member_com_acc', member_acc_id)
      api.post('/account/estimate/price', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
          setEst_from(response.data?.Form_Price);
          setEst_to(response.data?.To_Price);
      }).catch(function (error){
        console.log(error)
      }).finally(function (){
          setLoading(false)  
      })
    }
}

    const est_price_edit = () => {
      setLoading(true)
      const data = new FormData()
      data.append('commodity_id', commodity_id)
        data.append('grade_id', grade_edit)
        data.append('unit_id', unit_edit)
        data.append('amount_storing', number_of_bags_edit)
        data.append('member_com_acc', member_acc_id)
      api.post('/account/estimate/price', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
         setEst_from(response.data?.Form_Price);
         setEst_to(response.data?.To_Price);
      }).catch(function (error){
        console.log(error)
      }).finally(function (){
         setLoading(false)  
      })
    }

  const handleCancelOrder = (order_id) =>{
    const data = new FormData()
    data.append('order_id', order_id)
    api.post('/account/order/cancel', data ,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
       toast.success(response.data)
       get_orders();
       fetch_all_orders();
    }).catch(function (error){
      console.log(error)
    })
  }

  useEffect(()=>{
    if (formik_sell.values.transaction_id){
      available_sells.map(item=> 
        item.id === formik_sell.values.transaction_id ?
        setNum_komot(item.bags_left)
        :
        null
        )
    }
  },[formik_sell.values.transaction_id])

  useEffect(()=>{
    if (formik_sell.values.transaction_id &&  num_komot > 0){
      const data = new FormData()
      data.append('commodity_id', commodity_id)
      data.append('transaction_id', formik_sell.values.transaction_id)
      data.append('amount_retrieving', formik_sell.values.quantity_sell)
      data.append('member_com_acc', member_acc_id)
      data.append('date', '')
      api.post('/account/retrive/commodities/process/done', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setSelling_price(response.data.total_cash_value)
      })
    }
  },[formik_sell.values.transaction_id, formik_sell.values.quantity_sell])

  useEffect(()=>{
    if (number_of_bags_edit &&  num_komot > 0){
      const data = new FormData()
      data.append('commodity_id', commodity_id)
      data.append('transaction_id', edit_details.co_transaction_id)
      data.append('amount_retrieving', number_of_bags_edit)
      data.append('member_com_acc', member_acc_id)
      data.append('date', '')
      api.post('/account/retrive/commodities/process/done', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setSelling_price1(response.data.total_cash_value)
      })
    }
  },[number_of_bags_edit, num_komot])


  const handleEditOrder =  (order_id) => {
    api.get(`/account/order/details/${order_id}`,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setEdit_details(response.data?.order_details);
      setGrade_edit(response.data?.order_details.grade);
      setUnit_edit(response.data?.order_details.units);
      setNumber_of_bags_edit(response.data?.order_details.bags);
      setSpecs_edit(response.data?.order_details.message);
      fetch_stuffs(response.data?.order_details.commodity_id);
      setModal_open(true);
    }).catch(function (error){
      console.log(error);
    })
  }

  const handleEditOrderSell =  (order_id) => {
    api.get(`/account/order/details/sell/${order_id}`,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setEdit_details(response.data?.order_details);
      setNumber_of_bags_edit(response.data?.order_details.bags);
      setSpecs_edit(response.data?.order_details.message);
      setNum_komot(response.data?.transaction_d)
      setModal_open1(true);
    }).catch(function (error){
      console.log(error);
    })
  }

  const handleEditSubmission = (event) => {
    event.preventDefault()
    const data = new FormData()
    data.append('order_id', edit_details.order_id)
    data.append('grade', grade_edit)
    data.append('units', unit_edit)
    data.append('message', specs_edit)
    data.append('bags', number_of_bags_edit)
    handleOpen()
    api.post('/account/order/edit', data ,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
       toast.success(response.data);
       setGrade_edit(null)
       setUnit_edit(null)
       setNumber_of_bags_edit(null)
       setSpecs_edit('')
       setEdit_details()
       setNum_komot(null)
       setModal_open(false)
    }).catch(function (error){
      console.log(error)
    }).finally(function (){
       handleCloses();
       get_orders();
    })
  }

  const handleEditSubmission1 = (event) => {
    event.preventDefault()
    const data = new FormData()
    data.append('order_id', edit_details.order_id)
    data.append('message', specs_edit)
    data.append('bags', number_of_bags_edit)
    if(number_of_bags_edit > num_komot){
      setError1('You do not have this amount of bags')
    }else{
      handleOpen()
      api.post('/account/order/edit', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        toast.success(response.data);
        setGrade_edit(null)
        setUnit_edit(null)
        setNumber_of_bags_edit(null)
        setSpecs_edit('')
        setEdit_details()
        setNum_komot(null)
        setModal_open1(false)
        setSelling_price1(null)
      }).catch(function (error){
        console.log(error)
      }).finally(function (){
        handleCloses();
        get_orders();
      })
    }
    
  }


  const payLoan = (e) => {
    e.preventDefault()
    const data = {
      transactiontype_id: 1,
      Amount: repayment_amount,
      narration: 'Commodity loan repayment',
      loans_acc_id: member_acc_id,
      type: 'commodity',
      percent: null
    }
    api.post('/transactions/transaction/loans', data , {
      headers: {
          Authorization:'Bearer ' + fetchToken(),
      },
    }).then(function (response) {
        if(response.data === "Warehouse loan account not available"){
          toast.error(response.data);
        }else{
          toast.success(response.data);
          get_orders();
        }
    }).catch(function (error){
        console.log(error)
    })
  }

  const handleReciept = (id) => {
      if(permissions && permissions.download_loan_advise === true){
          api.get(`/transactions/loan/advise/commodity/${id}`, {
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            },
          }).then(function (response){
              setOpennn(<LoanAdviseCommodity Loan_Details={response.data?.Loan_Details} More_Details={response.data?.More_Details} Transaction_Details={response.data?.Transaction_Details} Repayment_Schedule={response.data?.Repayment_Schedule}  Amount_Total={response.data?.Amount_Total} Interest_Total={response.data?.Interest_Total} Total_Khraa={response.data?.Total_Khraa} />)
          }).catch(function (error){
            console.log(error);
          });
      }else{
        toast.error("Not Authorized")
      }
  }



  return(
    <>
    <Grid item xs={12} md={8}>
      <Item>
        <Box
          display='flex'
          marginLeft='10px'
          marginRight='10px'
          justifyContent='space-between'
        >
          <div style={{ display:'flex',marginTop:1 }}>
            <Avatar
              sx={{ width: 65, height: 65, backgroundColor:'#144552' }}
            >
              <span style={{ color:'#fff' }}>{getInitials(commodity)}</span>
            </Avatar>
            <div style={{ margin:5, display:'block' }}>
              <Typography 
                variant='h4' 
                fontStyle='normal' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
              <b>{commodity}</b>
              </Typography>
              
              <Typography 
                variant='subtitle' 
                fontStyle='Italic' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              > <b>Bags Units: </b>
                {
                  general_units.map((item) => (
                    `${item.units}kg `
                  ))
                }
              </Typography>
              <div>
              <Typography 
                variant='subtitle' 
                fontStyle='Italic' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >Currently in <b>{society_name} | {(warehouse.includes("Warehouse") ||
                                                  warehouse.includes("warehouse") ||
                                                  warehouse.includes("Wearhouse") ||
                                                  warehouse.includes("wearhouse"))
                                                  ?
                                                  warehouse 
                                                  :
                                                    `${warehouse} Warehouse`
                                                }</b>
              </Typography>
              </div>
            </div>
          </div>

          <div>
          {
            general_prices && general_prices.map((item)=>(
                <div style={{ display: 'block' }}>
                    <Chip
                        key={item.id}
                        label={<b><i>{`${item.grade}: ${currencyFormat.format(item.price_per_kg)}/kg`}</i></b>}
                        size='small'
                        variant='outlined'
                        sx={{ backgroundColor:'#0b525b', color:'#fff',mb:'2px', borderRadius:1 }}
                    />
                </div>
            ))
            }
          </div>
        </Box>
        <Divider variant='middle' sx={{ mt:1, mb:2 }}/>
      </Item>
      {opennn}
      {/* Chart */}
      <Itemc>
        <Box sx={{ height: 450 }}>
          {
            priceData?
            <PriceChart chartData={priceData.grade === "Grade A"?chartData_a:priceData.grade === "Grade B"?chartData_b:chartData_c} priceData={priceData} />:
            <Box sx={{ m:10 }}>
              <CircularProgress size={25} />
            </Box>
          }
          <Tooltip title="Select Grade to view chart">
            <Box>
              <Chip label="Grade A" onClick={() => changeChart("Grade A")} size='small' variant='outlined' sx={{ backgroundColor:'#0b525b', color:'#fff',mb:'2px', borderRadius:2 }} />
              <Chip label="Grade B" onClick={() => changeChart("Grade B")} size='small' variant='outlined' sx={{ backgroundColor:'#0b525b', color:'#fff',mb:'2px', borderRadius:2 }} />
              <Chip label="Grade C" onClick={() => changeChart("Grade C")} size='small' variant='outlined' sx={{ backgroundColor:'#0b525b', color:'#fff',mb:'2px', borderRadius:2 }} />
            </Box>
          </Tooltip>
        </Box>
      </Itemc>
      <Itemc> 
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value1} onChange={handleChange1} aria-label="basic tabs example">
              <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Open</b>} {...a11yProps(0)} />
              <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Pending</b>} {...a11yProps(1)} />
              <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Closed</b>} {...a11yProps(2)} />
              <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Loan</b>} {...a11yProps(3)} />
            </Tabs>
          </Box>
          {/* <Typography fontStyle='normal' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>My Orders</b></Typography> */}
          <CustomTabPanel value={value1} index={0}>
          <Box sx={{ maxWidth: 850, overflowX: 'auto',maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
            <Table sx={{ width: 999 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Commodity</TableCell>
                  <TableCell align="right">Date</TableCell>
                  <TableCell align="right">Type</TableCell>
                  <TableCell align="right">Bags</TableCell>
                  <TableCell align="right">Grade</TableCell>
                  <TableCell align="right">Unit</TableCell>
                  <TableCell align="right">Selling price</TableCell>
                  <TableCell align="right">Additional specifications</TableCell>
                  {/* <TableCell align="right">Open Price</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {orders_open.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow
                    key={row.order_id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                  >
                    <TableCell component="th" scope="row">
                      {row.commodity}
                    </TableCell>
                    <TableCell align="right"><FormatedDate value={row.date} /></TableCell>
                    <TableCell align="right"><b style={{ color:row.order_type === "Buy"?"blue":"red" }}>{row.order_type}</b></TableCell>
                    <TableCell align="right">{row.bags}</TableCell>
                    <TableCell align="right">{row.grade}</TableCell>
                    <TableCell align="right">{row.unit}</TableCell>
                    <TableCell align="right">{row.open_price? currencyFormat.format(row.open_price): "None"}</TableCell>
                    <TableCell align="right">{row.message}</TableCell>
                    <TableCell align="right"><Tooltip title="Modify order">
                      {
                        row.order_type === "Buy"?
                        <IconButton onClick={()=>handleEditOrder(row.order_id)}><BorderColorIcon /></IconButton>
                        :<IconButton onClick={()=>handleEditOrderSell(row.order_id)}><BorderColorIcon /></IconButton>
                      }
                       </Tooltip></TableCell>
                    <TableCell align="right"><Tooltip title="Cancel order"><IconButton onClick={()=>handleCancelOrder(row.order_id)}><CancelIcon /></IconButton></Tooltip></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={orders_open.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
            
          </CustomTabPanel>
          <CustomTabPanel value={value1} index={1}>
          <Box sx={{ maxWidth: 850, overflowX: 'auto',maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
            <Table sx={{ width: 999 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Commodity</TableCell>
                  <TableCell align="right">Date</TableCell>
                  <TableCell align="right">Type</TableCell>
                  <TableCell align="right">Bags</TableCell>
                  <TableCell align="right">Grade</TableCell>
                  <TableCell align="right">Unit</TableCell>
                  <TableCell align="right">Selling price</TableCell>
                  <TableCell align="right">Additional specifications</TableCell>
                  {/* <TableCell align="right">Open Price</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {orders_pending.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                  <TableRow
                    key={row.order_id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                  >
                    <TableCell component="th" scope="row">
                      {row.commodity}
                    </TableCell>
                    <TableCell align="right"><FormatedDate value={row.date} /></TableCell>
                    <TableCell align="right"><b style={{ color:row.order_type === "Buy"?"blue":"red" }}>{row.order_type}</b></TableCell>
                    <TableCell align="right">{row.bags}</TableCell>
                    <TableCell align="right">{row.grade}</TableCell>
                    <TableCell align="right">{row.unit}</TableCell>
                    <TableCell align="right">{row.open_price? currencyFormat.format(row.open_price): "None"}</TableCell>
                    <TableCell align="right">{row.message}</TableCell>
                    <TableCell align="right"><Tooltip title="Edit order"><BorderColorIcon /></Tooltip></TableCell>
                    <TableCell align="right"><Tooltip title="Cancel order"><IconButton onClick={()=>handleCancelOrder(row.order_id)}><CancelIcon /></IconButton></Tooltip></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={orders_pending.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
          </CustomTabPanel>
          <CustomTabPanel value={value1} index={2}>
          <Box sx={{ maxWidth: 850, overflowX: 'auto',maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
            <Table sx={{ width: 999 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Commodity</TableCell>
                  <TableCell align="right">Date</TableCell>
                  <TableCell align="right">Type</TableCell>
                  <TableCell align="right">Bags</TableCell>
                  <TableCell align="right">Grade</TableCell>
                  <TableCell align="right">Unit</TableCell>
                  <TableCell align="right">Selling price</TableCell>
                  <TableCell align="right">Additional specifications</TableCell>
                  {/* <TableCell align="right">Open Price</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {orders_closed.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                  <TableRow
                    key={row.order_id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                  >
                    <TableCell component="th" scope="row">
                      {row.commodity}
                    </TableCell>
                    <TableCell align="right"><FormatedDate value={row.date} /></TableCell>
                    <TableCell align="right"><b style={{ color:row.order_type === "Buy"?"blue":"red" }}>{row.order_type}</b></TableCell>
                    <TableCell align="right">{row.bags}</TableCell>
                    <TableCell align="right">{row.grade}</TableCell>
                    <TableCell align="right">{row.unit}</TableCell>
                    <TableCell align="right">{row.open_price? currencyFormat.format(row.open_price): "None"}</TableCell>
                    <TableCell align="right">{row.message}</TableCell>
                    {/* <TableCell align="right"><Tooltip title="Edit order"><BorderColorIcon /></Tooltip></TableCell> */}
                    {/* <TableCell align="right"><Tooltip title="Cancel order"><IconButton onClick={()=>handleCancelOrder(row.order_id)}><CancelIcon /></IconButton></Tooltip></TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={orders_closed.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value1} index={3}>
          <Box sx={{ maxWidth: 850, overflowX: 'auto',maxHeight: 240, overflowY: 'auto', '&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
            <Table sx={{ width: 999 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell align="right">Requested Amount</TableCell>
                  <TableCell align="right">Recommended Amount</TableCell>
                  <TableCell align="right">Status</TableCell>
                  <TableCell align="right">Account Balance</TableCell>
                  <TableCell align="right">Narration</TableCell>
                  <TableCell align="right">Type</TableCell>
                  <TableCell align="right">Print Advise</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loans_orders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                  <TableRow
                    key={row.transaction_id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                  >
                    <TableCell><FormatedDate value={row.transaction_date} /></TableCell>
                    <TableCell align="right">{currencyFormat.format(row.amount)}</TableCell>
                    <TableCell align="right">{row.recommended_amount?currencyFormat.format(row.recommended_amount):currencyFormat.format(0)}</TableCell>
                    <TableCell align="right">{row.status}</TableCell>
                    <TableCell align="right">{currencyFormat.format(row.balance)}</TableCell>
                    <TableCell align="right">{row.narration}</TableCell>
                    <TableCell align="right"><b style={{ color:row.transactiontype_id === 1?"blue":"red" }}>{row.transactiontype_id === 1?"Repayment":"Not repayment"}</b></TableCell>
                    <TableCell align="right">{row.status === "Disbursed"? <IconButton onClick={()=>handleReciept(row.transaction_id)}><PrintOutlinedIcon /></IconButton>: null}</TableCell>
                    {/* <TableCell align="right"><Tooltip title="Cancel order"><IconButton onClick={()=>handleCancelOrder(row.order_id)}><CancelIcon /></IconButton></Tooltip></TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={loans_orders.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
          </CustomTabPanel>
        </Box>
      </Itemc>
      <Modal
        open={modal_Open}
        onClose={handle_modal_Closee}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            {
              edit_details && edit_details.grade?
                <div>
                  <Typography variant='h5' fontStyle='italic' textAlign='center'><b>Modify Order</b></Typography>
                    <form onSubmit={handleEditSubmission}>
                        <div style={{ display:'flex' }}>
                          <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>Grade</Typography>
                          <Select
                            size='small'
                            sx={{ m:1 }}
                            fullWidth
                            name='grade_edit'
                            value={grade_edit}
                            onChange={(event)=> setGrade_edit(event.target.value)}
                          >
                          <MenuItem value={0}>Any</MenuItem>
                          {
                            general_prices.map((item)=>(
                              <MenuItem key={item.id} value={item.id}>{item.grade}</MenuItem>
                            ))
                          }
                          </Select>
                      </div>

                      <div style={{ display:'flex' }}>
                          <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>Unit/kg</Typography>
                          <Select
                            size='small'
                            sx={{ m:1 }}
                            fullWidth
                            value={unit_edit}
                            onChange={(event)=> setUnit_edit(event.target.value)}
                            name='unit_edit'
                          >
                              <MenuItem key={0} value={0}>Any</MenuItem>
                          {
                            general_units.map((item) => (
                              <MenuItem key={item.unit_id} value={item.unit_id}>{item.units}</MenuItem>
                            ))
                          }
                          </Select>
                      </div>

                      <div style={{ display:'flex' }}>
                          <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'> Number of bags</Typography>
                          <TextField
                            size='small'
                            sx={{ m:1 }}
                            fullWidth
                            type='number'
                            name='number_of_bags_edit'
                            value={number_of_bags_edit}
                            onChange={(event)=> setNumber_of_bags_edit(event.target.value)}
                          />
                      </div>

                      <div style={{ display:'flex' }}>
                        <Typography sx={{ marginTop:'8px' }} fontStyle='oblique' variant='subtitle'><b style={{ color:'darkblue' }}>Additional Infomation</b></Typography>
                        <Switch
                          checked={checked10}
                          onChange={handleFormChange10}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </div>

                      {
                        checked10?
                        <div style={{ display: 'flex' }}>
                          <TextField
                            fullWidth
                            multiline
                            sx={{ margin:'5px' }}
                            rows={4}
                            size="small"
                            name='specs_edit'
                            value={specs_edit}
                            onChange={(event) => setSpecs_edit(event.target.value)}
                            placeholder='Type here'
                          />
                        </div>
                        :
                        null
                      }

                      <div style={{ display:'flex' }}>
                          <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>Calculate estimated price
                          {
                            loading === true?
                            <CircularProgress size={20} className="circular-progress"/>
                            : 
                            <IconButton onClick={est_price_edit}><CalculateIcon sx={{ color:'#0d3b66' }} /></IconButton>
                          }
                          
                          {
                            est_from?
                            <Typography fontStyle='italic' variant='h6'><b style={{ color:'#001845' }}>{`${currencyFormat.format(est_from)} ~ ${currencyFormat.format(est_to)}`}</b></Typography>
                            :
                            null
                          }
                          </Typography>
                      </div>
                      <div style={{ display:'flex', textAlign: 'center', marginTop: '10px' }}>
                          <Button type='submit' fullWidth variant="contained" sx={{ backgroundColor: '#3a0ca3'}} size='small'><b style={{ color:'#fff' }}>Confirm Edit</b></Button>
                      </div>
                      <div style={{ display:'flex', textAlign: 'center', marginTop: '5px' }}>
                          <Button onClick={handle_modal_Closee} fullWidth variant="contained" sx={{ backgroundColor: 'red'}} size='small'><b style={{ color:'#fff' }}>Cancel Edit</b></Button>
                      </div>
                    </form>
                </div>
              :
              <div style={{ display:'flex', textAlign:'center' }}><CircularProgress size={20} /></div>
            }
        </Box>
      </Modal>

      <Modal
        open={modal_Open1}
        onClose={()=>setModal_open1(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            {
              edit_details && edit_details.grade?
                <div>
                  <Typography variant='h5' fontStyle='italic' textAlign='center'><b>Modify Order</b></Typography>
                    <form onSubmit={handleEditSubmission1}>
                      {
                        num_komot?
                        <Typography sx={{ textAlign: 'center' }} variant='body1' fontFamily='Monospace' fontStyle='oblique'>Available Bags: <b>{num_komot}</b></Typography>
                        :
                        null
                      }
                      <div style={{ display:'flex' }}>
                          <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'> Number of bags</Typography>
                          <TextField
                            size='small'
                            sx={{ m:1 }}
                            fullWidth
                            helperText={<p style={{ color:'red' }}>{error1}</p>}
                            type='number'
                            name='number_of_bags_edit'
                            value={number_of_bags_edit}
                            onChange={(event)=> setNumber_of_bags_edit(event.target.value)}
                          />
                      </div>
                      <div style={{ display:'flex' }}>
                        <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>
                          Selling Price: <b>{currencyFormat.format(selling_price1)}</b>
                        </Typography>                
                      </div>


                      <div style={{ display:'flex' }}>
                        <Typography sx={{ marginTop:'8px' }} fontStyle='oblique' variant='subtitle'><b style={{ color:'darkblue' }}>Additional Infomation</b></Typography>
                        <Switch
                          checked={checked10}
                          onChange={handleFormChange10}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </div>

                      {
                        checked10?
                        <div style={{ display: 'flex' }}>
                          <TextField
                            fullWidth
                            multiline
                            sx={{ margin:'5px' }}
                            rows={4}
                            size="small"
                            name='specs_edit'
                            value={specs_edit}
                            onChange={(event) => setSpecs_edit(event.target.value)}
                            placeholder='Type here'
                          />
                        </div>
                        :
                        null
                      }
                      <div style={{ display:'flex', textAlign: 'center', marginTop: '10px' }}>
                          <Button type='submit' fullWidth variant="contained" sx={{ backgroundColor: '#3a0ca3'}} size='small'><b style={{ color:'#fff' }}>Confirm Edit</b></Button>
                      </div>
                      <div style={{ display:'flex', textAlign: 'center', marginTop: '5px' }}>
                          <Button onClick={()=>setModal_open1(false)} fullWidth variant="contained" sx={{ backgroundColor: 'red'}} size='small'><b style={{ color:'#fff' }}>Cancel Edit</b></Button>
                      </div>
                    </form>
                </div>
              :
              <div style={{ display:'flex', textAlign:'center' }}><CircularProgress size={20} /></div>
            }
        </Box>
      </Modal>
    </Grid>

    {/* Order part */}
    <Grid item xs={12} md={4}  sx={{ mb:10 }}>
      <Item>
      <Box
          display='flex'
          marginLeft='10px'
          marginRight='10px'
          justifyContent='space-between'
      >
        <div style={{ display:'flex',marginTop:1 }}>
          {
            my_info?
            <Avatar
              sx={{ width: 65, height: 65 }}
              alt={my_info.member_name}
              src={pic(my_info.member_image)}
            />
            : null
          }
            
            <div style={{ margin:5, display:'block' }}>
              <Typography 
                variant='body1' 
                fontStyle='normal' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              ><b>{my_info.member_name}</b>
              </Typography>
            </div>
        </div>
        
        <div style={{ display:'block' }}>
          {
            my_info && my_info.exist === "yes"?
            <>
            <Typography 
              variant='subtitle' 
              fontStyle='Italic' 
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
               <b>My {commodity}</b>
            </Typography>
            <div style={{ display:'block' }}>
              <Typography sx={{ m:'1px' }} variant='subtitle' fontStyle='Italic' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              > Bags: <b>{my_info.bags}</b>
              </Typography>
            </div>
            <div style={{ display:'block' }}>
              <Typography sx={{ m:'1px' }} variant='subtitle' fontStyle='Italic' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              > Value: <b>{currencyFormat.format(my_info.value)}</b>
              </Typography> 
              </div>
              <div style={{ display:'block' }}>
              <Typography sx={{ m:'1px' }} variant='subtitle' fontStyle='Italic' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              > Weight: <b>{my_info.weight}kg</b>
              </Typography>
              </div>
              <div style={{ display:'block' }}>
              <Typography sx={{ m:'1px' }} variant='subtitle' fontStyle='Italic' 
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              > Tonnes: <b>{my_info.weight / 1000}tons</b>
              </Typography>
              </div>
            </>
            :
            <Typography 
              variant='subtitle' 
              fontStyle='Italic' 
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              You don't have any {commodity} at the moment.
            </Typography>
          }
        </div>
      </Box>

          <Divider variant='middle' sx={{ mt:1, mb:1 }} />
          
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label={<b style={{ color: 'Blue', fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Buy</b>} {...a11yProps(0)} />
                <Tab label={<b style={{ color: 'red', fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Sell</b>} {...a11yProps(1)} />
                <Tab label={<b style={{ color: 'gray', fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Loan</b>} {...a11yProps(2)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <form onSubmit={formik.handleSubmit}>
                  <div style={{ display:'flex' }}>
                    <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>Grade</Typography>
                    <Select
                      size='small'
                      sx={{ m:1 }}
                      fullWidth
                      name='grade'
                      value={formik.values.grade}
                      onChange={formik.handleChange}
                    >
                    <MenuItem value={0}>Any</MenuItem>
                    {
                      general_prices.map((item)=>(
                        <MenuItem key={item.id} value={item.id}>{item.grade}</MenuItem>
                      ))
                    }
                    </Select>
                </div>

                <div style={{ display:'flex' }}>
                    <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>Unit/kg</Typography>
                    <Select
                      size='small'
                      sx={{ m:1 }}
                      fullWidth
                      value={formik.values.unitsKg}
                      onChange={formik.handleChange}
                      name='unitsKg'
                    >
                        <MenuItem key={0} value={0}>Any</MenuItem>
                    {
                      general_units.map((item) => (
                        <MenuItem key={item.unit_id} value={item.unit_id}>{item.units}</MenuItem>
                      ))
                    }
                    </Select>
                </div>

                <div style={{ display:'flex' }}>
                    <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'> Number of bags</Typography>
                    <TextField
                      size='small'
                      sx={{ m:1 }}
                      fullWidth
                      type='number'
                      name='quantity'
                      value={formik.values.quantity}
                      onChange={formik.handleChange}
                    />
                </div>

                <div style={{ display:'flex' }}>
                  <Typography sx={{ marginTop:'8px' }} fontStyle='oblique' variant='subtitle'><b style={{ color:'darkblue' }}>Additional Infomation</b></Typography>
                  <Switch
                    checked={checked}
                    onChange={handleFormChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>

                {
                  checked?
                  <div style={{ display: 'flex' }}>
                    <TextField
                      fullWidth
                      multiline
                      sx={{ margin:'5px' }}
                      rows={4}
                      size="small"
                      name='specs'
                      value={formik.values.specs}
                      onChange={formik.handleChange}
                      placeholder='Type here'
                    />
                  </div>
                  :
                  null
                }

                <div style={{ display:'flex' }}>
                    <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>Calculate estimated price
                    {
                      loading === true?
                      <CircularProgress size={20} className="circular-progress"/>
                      : 
                      <IconButton onClick={est_price}><CalculateIcon sx={{ color:'#0d3b66' }} /></IconButton>
                    }
                    
                    {
                      est_from?
                      <Typography fontStyle='italic' variant='h6'><b style={{ color:'#001845' }}>{`${currencyFormat.format(est_from)} ~ ${currencyFormat.format(est_to)}`}</b></Typography>
                      :
                      null
                    }
                    </Typography>
                </div>
                <div style={{ display:'flex', textAlign: 'center', marginTop: '10px' }}>
                    <Button type='submit' fullWidth variant="contained" sx={{ backgroundColor: '#3a0ca3'}} size='small'><b style={{ color:'#fff' }}>Confirm Order</b></Button>
                </div>
              </form>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openn}
                onClick={handleCloses}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
            {
              my_info && my_info.exist === "yes"?
              <form onSubmit={formik_sell.handleSubmit}>
                <Typography sx={{ textAlign: 'center', color:'#780000' }} variant='subtitle' fontFamily='Monospace' fontStyle='oblique'>
                  Activities with all their bags retrieved or already in the market will not be displayed here.
                </Typography>
                  <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={available_sells}
                      sx={{ mt:3, marginBottom:1 }}
                      getOptionLabel={(option) => `Activity id: ${option.id}`}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <DemChips 
                            id={option.id} 
                            date={option.date} 
                            cash={currencyFormat.format(option.cash_worth)} 
                            grade={option.grade} 
                            unit={option.unit} 
                            bags={option.bags}/>
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      onChange={(event, value) => {
                          if (value) {
                            formik_sell.setFieldValue("transaction_id", value.id)
                          }
                      }}
                      renderInput={(params) => 
                      <TextField {...params} 
                        fullWidth  
                        label="Select Activity" 
                        size="small" 
                      />}
                  />
                  <div style={{ display:'flex' }}>
                    <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'> Number of bags</Typography>
                    <TextField
                      margin="dense"
                      name="quantity_sell"
                      value={formik_sell.values.quantity_sell}
                      onChange={formik_sell.handleChange}
                      onBlur={formik_sell.handleBlur}
                      error={formik_sell.touched.quantity_sell && Boolean(formik_sell.errors.quantity_sell)}
                      helperText={formik_sell.touched.quantity_sell && formik_sell.errors.quantity_sell}
                      type="number"
                      size="small"
                      variant="outlined"
                    />
                  </div>
                  {
                    num_komot?
                    <Typography sx={{ textAlign: 'center' }} variant='body1' fontFamily='Monospace' fontStyle='oblique'>Bags left: <b>{num_komot}</b></Typography>
                    :
                    null
                  }
                  <div style={{ display:'flex' }}>
                  <Typography sx={{ marginTop:'8px' }} fontStyle='oblique' variant='subtitle'><b style={{ color:'darkblue' }}>Additional Infomation</b></Typography>
                  <Switch
                    checked={checked1}
                    onChange={handleFormChange1}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>

                {
                  checked1?
                  <div style={{ display: 'flex' }}>
                    <TextField
                      fullWidth
                      multiline
                      sx={{ margin:'5px' }}
                      rows={4}
                      size="small"
                      name='specs_sell'
                      value={formik_sell.values.specs_sell}
                      onChange={formik_sell.handleChange}
                      placeholder='Type here'
                    />
                  </div>
                  :
                  null
                }
                  <div style={{ display:'flex' }}>
                    <Typography sx={{ m:1, mt:1, alignSelf: 'center' }} variant='h6' fontStyle='oblique'>
                      Selling Price: <b>{currencyFormat.format(selling_price)}</b>
                    </Typography>                
                  </div>
                  <div style={{ display:'flex', textAlign: 'center', marginTop: '10px' }}>
                      <Button type='submit' fullWidth variant="contained" sx={{ backgroundColor: '#d90429'}} size='small'><b style={{ color:'#fff' }}>Confirm Order</b></Button>
                  </div>
              </form>
              
              :
              <Typography textAlign='center' fontStyle='italic' variant='h6'><b style={{ color:'#001845' }}>You do not have {commodity} to sell.</b></Typography>
            }
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Typography sx={{ textAlign: 'center', color:'#780000' }} variant='subtitle' fontFamily='Monospace' fontStyle='oblique'>
                <b>
                  Loan request depends on the value of the number of commodities you own. 
                  Thus, you can not request an amount more that your commodities total value.
                </b>
              </Typography>
            
              <Box sx={{ mt:3 }}>
                {
                  my_info && my_info.has_any === true?
                    
                  requested === true?
                      <>
                          <div>
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              variant='h5'
                            >
                              <b>Pending loan request: {currencyFormat.format(requested_amount)}</b>
                            </Typography>
                            <div style={{ display:'flex', textAlign: 'center', marginTop: '10px' }}>
                              <Button onClick={cancelrequestLoan} fullWidth variant="contained" sx={{ backgroundColor: '#d90429'}} size='small'><b style={{ color:'#fff' }}>Cancel request</b></Button>
                            </div>
                          </div>
                      </>
                      :deka_amount !== 0?
                        <Box>
                          <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant='h4'
                            sx={{ textAlign: 'center' }}
                          >
                            <b>Outstanding loan: {currencyFormat.format(deka_amount)}</b>
                          </Typography>
                          <Box sx={{ display:'block' }}>
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Repayment starts on <FormatedDateRepayments value={repayment_starts}/></b>
                            </Typography>
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Repayment ends on <FormatedDateRepayments value={repayment_ends}/></b>
                            </Typography>
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              sx={{ m:2 }}
                            >
                              <b>{percent}% done</b>
                            </Typography>
                          </Box>
                          <form onSubmit={payLoan}>
                            <TextField
                              size='small'
                              label= "Amount to repay"
                              type = "number"
                              name = "repayment_amount"
                              value={repayment_amount}
                              onChange={(e) => setRepayment_amount(e.target.value)}
                              required
                              min={1}
                              max={deka_amount}
                              sx={{ m:1 }}
                            />
                            <div style={{ display:'flex', textAlign: 'center', marginTop: '10px' }}>
                              <Button type='submit' fullWidth variant="contained" color='success' size='small'><b style={{ color:'#fff' }}>Pay loan</b></Button>
                            </div>
                          </form>
                          
                        </Box>
                      :
                      <Box>
                        <Typography
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          variant='body2'
                        >
                          <b>Set percentage</b>
                        </Typography>

                        <PrettoSlider
                          valueLabelDisplay="auto"
                          aria-label="pretto slider"
                          value={slider_value}
                          onChange={changeSliderValue}
                          step={10}
                          marks
                          sx={{ mb:2 }}
                        />

                          <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant='h5'
                            fontStyle='italic'
                          >
                            Loan value: <b>{currencyFormat.format(slider_final)}</b>
                          </Typography>

                        <Divider  variant='middle' sx={{ m:1 }}/>
                        <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant='h5'
                            fontStyle='italic'
                        >
                          Total value: <b>{currencyFormat.format(my_info.cash_val)}</b>
                        </Typography>
                        
                        <div style={{ display:'flex', textAlign: 'center', marginTop: '10px' }}>
                          <Button onClick={requestLoan} fullWidth variant="contained" color='success' size='small'><b style={{ color:'#fff' }}>Request loan</b></Button>
                        </div>
                    </Box>
                    
                  :
                  <Typography 
                    variant='subtitle' 
                    fontStyle='Italic' 
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>You don't have any commodity at the moment.</b>
                  </Typography>
                }
              </Box>
              
            </CustomTabPanel>
          </Box>

      </Item>
    </Grid>
    </>
  )
}





const TradingAccount = () => {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const member_commodity_id = location.state && location.state.member_commodity_id;
    const society_id = location.state && location.state.society_id;
    const society = location.state && location.state.society;
    const warehouse = location.state && location.state.warehouse;
    const warehouse_id = location.state && location.state.warehouse_id;
    const [society_commodities, setSociety_commodities] = useState([]);
    const [search_commodity, SetSearch_commodity] = useState('')

    const [order, setOrder] = useState([]);
    const [state, setState] = useState({
      top: false,
      left: false,
      bottom: false,
      right: false,
    });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const fetch_all_orders = () => {
    api.get('/account/get/all/orders',{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setOrder(response.data?.all_orders);
    }).catch(function (error){
      console.log(error)
    })
  }
  useEffect(()=>{
    fetch_all_orders();
    // const intervalId = setInterval(fetch_all_orders, 2000);
    // return () => clearInterval(intervalId);
  },[])

  const orders = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 400 , mt:10}}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
     <Typography variant='h5' fontStyle='normal' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='center'><b>All Orders</b></Typography>
      <Box>
        {
          order && order.map((item)=>{
            if(item.order_type === "Buy"){
                return (
                  item?
                  <Box sx={{ display:'flex' }}>
                    <Item_order_buy>
                      <Typography
                        color='#fff'
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant='h6'
                        sx={{ mr:3, ml:1 }}
                      >
                      <b>{item.commodity}</b>
                      </Typography>

                      
                      <Typography
                        color='#fff'
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant='h6'
                        sx={{ mr:3 }}
                      >
                      <b>{item.bags}bags</b>
                      </Typography>

                      <Typography
                        color='#fff'
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant='h6'
                        sx={{ mr:7 }}
                      >
                      <b>{item.grade}</b>
                      </Typography>
                    </Item_order_buy>
                    <DetailsModal  item={item}/>
                  </Box>
                    
                  : <Box>
                    <CircularProgress size={45} />
                  </Box>
                )
            }else{
              return (
                item?
                  <Box sx={{ display:'flex' }}>
                    <Item_order_sell>
                      <Typography
                        color='#fff'
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant='h6'
                        sx={{ mr:3, ml:1 }}
                      >
                      <b>{item.commodity}</b>
                      </Typography>

                      
                      <Typography
                        color='#fff'
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant='h6'
                        sx={{ mr:3 }}
                      >
                      <b>{item.bags}bags</b>
                      </Typography>

                      <Typography
                        color='#fff'
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant='h6'
                        sx={{ mr:7 }}
                      >
                      <b>{item.grade}</b>
                      </Typography>
                    </Item_order_sell>
                    <DetailsModal  item={item}/>
                  </Box>
                    
                  : <Box>
                    <CircularProgress size={45} />
                  </Box>
                  
              )
            }
          })
        }
      </Box>

    </Box>
  );



    const fetch_society_commodities = () =>{
      const par = new FormData()
      par.append('society_id', society_id)
      par.append('search', search_commodity)

      api.post('/commodity/soc/commodity/trade', par,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        if (!society_commodities[0]){
          toast.info("Select commodity to open platform")
        }
        setSociety_commodities(response.data?.deep);
      })
    }

    const [details, setDetails] = useState()

    useEffect(()=>{
      fetch_society_commodities()
    },[])
    


    const back = async () => {
      SetSearch_commodity('')
      await fetch_society_commodities()
    }
    






    const Itemb = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(26, 32, 39, 0.5)' : 'rgba(255, 255, 255, 0.2)',
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
      borderRadius: '8px',
      
    }));

    const handleShow = (id, commodity) => {
      setDetails(<Trade 
        warehouse={warehouse} 
        commodity={commodity} 
        commodity_id={id} 
        member_acc_id={member_commodity_id} 
        society_id={society_id} 
        warehouse_id={warehouse_id}
        society_name={society}
        fetch_all_orders={fetch_all_orders}
      />)
    }

  return (
     <div className="app">
       <main className="content">
           <Box sx={{ m:5 }}>
             {/* HEADER */}
             <Box display="flex" justifyContent="space-between" alignItems="center">
               <Header title="Trading Dashboard" />
             </Box>
               <Grid container spacing={2}>
                  <Grid item xs={12} md={12}
                    sx={{ borderRadius: '8px', boxShadow:1,m:1 }}
                  >
                    {/* <Itemb> */}
                      {/* Search Bar */}
                      <Box display="flex">
                          <Box
                            display="flex"
                            backgroundColor='#dee2e6'
                            borderRadius="15px"
                            textAlign='center'
                            minWidth='1000px'
                            sx={{ overflowX: 'auto', maxWidth:'1001px', '&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
                          <InputBase
                            sx={{ ml: 2, flex: 1, borderRadius:10 }} 
                            placeholder="Search Commodity" 
                            name='search_commodity'
                            onChange={e => SetSearch_commodity(e.target.value)}
                            value={search_commodity}
                            fullWidth
                          />
                          <IconButton type="button" onClick={fetch_society_commodities} sx={{ p: 1 }}>
                            <SearchIcon />
                          </IconButton>
                        </Box>
                          <Box
                            backgroundColor='#dee2e6'
                            borderRadius="10px"
                            sx={{ ml:1, mr:2 }}
                          >
                            <IconButton onClick={back} type="button" sx={{ p:1 }}>
                              <CloseIcon />
                            </IconButton>
                          </Box>
                            <Button
                              onClick={toggleDrawer('left', true)}
                              color="success"
                              sx={{ borderRadius:7 }}
                              size='medium'
                              variant='contained'
                              endIcon={<ViewAgendaIcon/>}
                            >
                              {
                                orders?
                                "All Orders"
                                :
                                <CircularProgress size={25} />
                              }
                            </Button>
                          
                      </Box>
                      {/* List of commodities */}
                      <Box 
                        display='flex'
                        marginTop='5px'
                        sx={{ overflowX: 'auto', maxWidth:'550px', '&::-webkit-scrollbar': {
                            height: '5px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
                      
                        {
                          society_commodities?
                          society_commodities.map((item)=>(
                            <Chip key={item.id} label={item.commodity} sx={{ m:1, borderRadius:2 }} onClick={() => handleShow(item.id, item.commodity)} />
                          ))
                          :<Typography variant='subtitle' fontStyle='Italic'>Commodities in Society will appear here</Typography>
                        }
                      </Box>
                    {/* </Itemb> */}
                  </Grid>

                  {details}
                <SwipeableDrawer
                  anchor='left'
                  open={state['left']}
                  onClose={toggleDrawer('left', false)}
                  onOpen={toggleDrawer('left', true)}
                >
                  {orders('left')}
                </SwipeableDrawer>
               </Grid>
           </Box>
       </main>
     </div>
  )
}

export default TradingAccount